import { render, staticRenderFns } from "./CcDocStatus.vue?vue&type=template&id=6243de76&scoped=true"
import script from "./CcDocStatus.vue?vue&type=script&setup=true&lang=js"
export * from "./CcDocStatus.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CcDocStatus.vue?vue&type=style&index=0&id=6243de76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6243de76",
  null
  
)

export default component.exports